import { render } from "./JoinConfigSection.vue?vue&type=template&id=1b2fa2f2&scoped=true&ts=true"
import script from "./JoinConfigSection.vue?vue&type=script&lang=ts"
export * from "./JoinConfigSection.vue?vue&type=script&lang=ts"

import "./JoinConfigSection.vue?vue&type=style&index=0&id=1b2fa2f2&scoped=true&lang=css"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2fa2f2"]])

export default __exports__